// extracted by mini-css-extract-plugin
export var dividerContainer = "_8j-0";
export var line = "_8j-1";